/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { FormattedMessage } from 'react-intl'
import { Table } from '@mantine/core'
import NoData from '../../../../client/js/components/NoData'
import SelectionToggle from '../../../../client/js/components/selection/SelectionToggle'
import InterventionListItem from './InterventionListItem'
import { getInterventionLinkTemplate } from '../../lib/links/interventionLinks'

export type InterventionListProps = {
  items: Intervention[],
  itemLink?: string
}

function InterventionList (props: InterventionListProps) {
  const {
    items,
    itemLink = getInterventionLinkTemplate()
  } = props
  return (
    <Table highlightOnHover>
      <Table.Thead>
        <Table.Tr>
          <Table.Th w={50}>
            <SelectionToggle />
          </Table.Th>
          <Table.Th w={100}>
            <FormattedMessage
              id="state"
              defaultMessage="État"
            />
          </Table.Th>
          <Table.Th w={100}>
            <FormattedMessage
              id="date"
              defaultMessage="Date"
            />
          </Table.Th>
          <Table.Th w={80}>
            <FormattedMessage
              id="priority"
              defaultMessage="Priorité"
            />
          </Table.Th>
          <Table.Th>
            <FormattedMessage
              id="subject"
              defaultMessage="Sujet"
            />
          </Table.Th>
          <Table.Th>
            <FormattedMessage
              id="estate"
              defaultMessage="Bien"
            />
          </Table.Th>
          <Table.Th w={120}>
            <FormattedMessage
              id="start_date"
              defaultMessage="Date de début"
            />
          </Table.Th>
          <Table.Th w={120}>
            <FormattedMessage
              id="end_date"
              defaultMessage="Date de fin"
            />
          </Table.Th>
          <Table.Th>
            <FormattedMessage
              id="assignee"
              defaultMessage="Responsable"
            />
          </Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {items.length > 0
          ? items.map((item) => (
            <InterventionListItem
              item={item}
              itemLink={itemLink}
              key={item.id}
            />
          ))
          : <Table.Tr>
            <Table.Td colSpan={10}>
              <NoData />
            </Table.Td>
          </Table.Tr>
        }
      </Table.Tbody>
    </Table>
  )
}

export default InterventionList
